export default "__VITE_ASSET__7568c149__"